import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';
import 'flickity-bg-lazyload/bg-lazyload.js';
import 'jquery-match-height/dist/jquery.matchHeight.js';
import '../../inc/casadistance/dist/main-bundle.js';
import noUiSlider from 'nouislider';
import 'sticky-kit/dist/sticky-kit.min.js';
import 'lazysizes';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	var $ = jQuery;

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	var geoMarkers = [];
	var googleMapMarkers = [];

	function requestMarkers(map, url, oms){
	    deleteMarkers();
	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	       // console.log(elem);
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon
	             }
	         });
	      });
	      oms.removeAllMarkers();
	      setMarkers(map, geoMarkers, oms);
	    })
	}

	function setMarkers(map, geoMarkers, oms){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };

	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(34,44),
	                        null,
	                        null,
	                        new google.maps.Size(34,44)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: markerpos,
	              map: map,
	              title: '',
	              animation: google.maps.Animation.DROP,
	              url: feature.properties.link,
	              icon: icon
	            });


	            oms.addMarker(marker);
	            //googleMapMarkers.push(marker);
	          	//console.log(feature)
	            google.maps.event.addListener(marker, 'spider_click', function() {
	                window.open(this.url);
	            });
	            bounds.extend(markerpos);
	            }
	        });
	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom() - 1);
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for (var i = 0; i < googleMapMarkers.length; i++) {
	        googleMapMarkers[i].setMap(null);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}

	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}

	

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(window).height())));
	}


	function partInViewport(elem) {
		var x = elem.getBoundingClientRect().left;
		var y = elem.getBoundingClientRect().top;
		var ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		var hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		var w = elem.clientWidth;
		var h = elem.clientHeight;
		return (
			(y < hw &&
			 y + h > 0) &&
			(x < ww &&
			 x + w > 0)
		);
	}

	function revealElements() {
		var revealList = document.querySelectorAll('.reveal,.fadereveal');
		for (var i = 0; i < revealList.length; i++) {
			if (partInViewport(revealList.item(i))) {
				revealList.item(i).classList.add('revealed');
			}			
		}
	}

	function lazyloadImages() {
		var lazyloadList = document.getElementsByClassName("lazyload");
		for (var i = 0; i < lazyloadList.length; i++) {
			if (partInViewport(lazyloadList.item(i))) {
				lazyloadList.item(i).classList.add('lazyloaded');
				console.log('lazyloaded added')
				if (lazyloadList.item(i).getAttribute('data-bg')) {
					console.log('data-bg');
					var dataBG = lazyloadList.item(i).getAttribute('data-bg');
					console.log(dataBG);
					lazyloadList.item(i).setAttribute('style', 'background-image: url(' + dataBG + ')');
					console.log(lazyloadList.item(i));
				} else if(lazyloadList.item(i).getAttribute('data-src')) {
					var dataSRC = lazyloadList.item(i).getAttribute('data-src');
					lazyloadList.item(i).setAttribute('src', dataSRC);
				}
			}			
		}
	}

	
	revealElements();
	lazyloadImages();
	document.addEventListener('scroll', function () {
		revealElements();
		lazyloadImages();
	}, {
		passive: true
	});
	
		if ($('.replace-form').length) {
			$('#complexContactFormAnchor').replaceWith($('.wpforms-container'));

			$("#wpforms-form-60 .wpforms-field-label:contains('Bemerkungen:')").html('Firma:');

			$('#wpforms-form-60 .wpforms-field-select:last .wpforms-field-label').html('Ich interessiere mich für: *');

			$('#wpforms-form-60 .wpforms-field-select:last option').each(function(index, unit){
				//console.log($(unit).val());
				var value = $(unit).val() + ';';
				if(value != ';'){
					$(unit).val(value);	
				}
			});
			
			
		}

		$('.nav .menu-item-has-children > a').on('click', function(e){
			e.preventDefault();
			if ($(this).next().hasClass('sub-open')) {
				$('.nav .menu-item-has-children > a').next().removeClass('sub-open');
			} else {
				$('.nav .menu-item-has-children > a').next().removeClass('sub-open');
				$(this).next().addClass('sub-open');
			}
			return false;
		});

		$(".gallery-wrapper").lightGallery({
	      selector: ".wrapping-link",
	      thumbnail: false
	    });

		$('.link-to-bottom').on('click', function(){
			disable_scroll();
			$('html, body').stop().animate({
				scrollTop: $('.site-content').offset().top
			}, 700, function(){
				enable_scroll();
			});
			return false;
		});

		$('.navbar-toggler').on('click', function(){
			if ($(this).hasClass('active-nav')) {
				$(this).removeClass('active-nav');
				$('.navbar-outer').removeClass('nav-bg');
			} else {
				$(this).addClass('active-nav');
				$('.navbar-outer').addClass('nav-bg');
			}
		});

		$('.navbar-collapse').on('shown.bs.collapse', function(){
			$('#footer').hide();
			$('.site-content').hide();
			$('.slider-outer').hide();
			$('.navbar-toggler').removeClass('dontClick');
		});

		$('.navbar-collapse').on('show.bs.collapse', function(){
			$('.navbar-toggler').addClass('dontClick');
		});

		$('.navbar-collapse').on('hidden.bs.collapse', function(){
			$('.navbar-toggler').removeClass('dontClick');
		});

		$('.navbar-collapse').on('hide.bs.collapse', function(){
			$('#footer').show();
			$('.site-content').show();
			$('.slider-outer').show();
			$('.navbar-toggler').addClass('dontClick');
		});

		$('.match-height').matchHeight();

		$('.casadistance__menu__button').on('click', function(){
			$('html, body').animate({
				scrollTop: $('.casadistance__menu').offset().top - 150
			}, 500);
		});

		function make_sticky() {
		  $(".sticky-col .content-wrapper__inner").stick_in_parent({
		    offset_top: 200,
		  });
		}

		if ($(window).width() < 768) {
		  $("#sidebar").trigger("sticky_kit:detach");
		} else {
		  make_sticky();
		}

		


		/* Complex Manager */
		
		$('.col-quick-download a').html('<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">   	<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">   		<g id="Angebot" transform="translate(-1154.000000, -1575.000000)" stroke="#979797">            			<g id="Group-17" transform="translate(1129.000000, 1449.000000)">				<g id="Group-7" transform="translate(26.000000, 127.000000)">                   <line x1="3.43137255" y1="6.8627451" x2="11.5808824" y2="6.8627451" id="Path"></line>                    <line x1="3.43137255" y1="9.43627451" x2="8.57843137" y2="9.43627451" id="Path"></line>                    <line x1="3.43137255" y1="4.28921569" x2="9.43627451" y2="4.28921569" id="Path"></line>                    <line x1="3.43137255" y1="12.0098039" x2="6.8627451" y2="12.0098039" id="Path"></line>                    <line x1="3.43137255" y1="14.5833333" x2="6.8627451" y2="14.5833333" id="Path"></line>                    <path d="M8.57843137,19.7303922 L0.857843137,19.7303922 C0.384069455,19.7303922 -2.50466314e-13,19.3463227 -2.50466314e-13,18.872549 L-2.50466314e-13,0.857843137 C-2.50466314e-13,0.384069455 0.384069455,1.0658141e-14 0.857843137,1.0658141e-14 L12.261152,1.0658141e-14 C12.4886475,1.0658141e-14 12.7068077,0.0904600951 12.8676471,0.251348039 L16.0476716,3.43137255 C16.2085595,3.5922119 16.2990196,3.8103721 16.2990196,4.03786765 L16.2990196,6.8627451" id="Path"></path>                    <path d="M9.43627451,14.5833333 C9.43627451,17.4259754 11.7406912,19.7303922 14.5833333,19.7303922 C17.4259754,19.7303922 19.7303922,17.4259754 19.7303922,14.5833333 C19.7303922,11.7406912 17.4259754,9.43627451 14.5833333,9.43627451 C11.7406912,9.43627451 9.43627451,11.7406912 9.43627451,14.5833333 Z" id="Path"></path>                    <line x1="14.5833333" y1="12.0098039" x2="14.5833333" y2="17.1568627" id="Path"></line>                    <line x1="14.5833333" y1="17.1568627" x2="12.6531863" y2="15.2267157" id="Path"></line>                    <line x1="14.5833333" y1="17.1568627" x2="16.5134804" y2="15.2267157" id="Path"></line>                </g>            </g>        </g>    </g></svg>');
		$('.col-r_link a').html('<svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Angebot" transform="translate(-1228.000000, -1495.000000)" fill-rule="nonzero"> <g id="Group-3" transform="translate(1207.000000, 1449.000000)"><g id="Group" transform="translate(21.000000, 46.000000)"><circle id="Oval" fill="#979797" cx="10.0055279" cy="10.0055279" r="10.0055279"></circle><g transform="translate(4.864566, 2.985075)" fill="#FFFFFF" id="Path"> <path d="M1.16086235,6.47871752 L0.0331674959,13.0348259 C0.0884466556,13.1232725 0.265339967,13.1343284 0.34273079,13.0679934 C0.585959093,12.0066335 1.89054726,6.66666667 1.89054726,6.66666667 C1.63626313,6.62244334 1.16086235,6.47871752 1.16086235,6.47871752 Z"></path><path d="M3.75898286,6.88778331 L4.22332781,11.3543394 C4.33388612,11.4096186 4.44444444,11.4317302 4.54394693,11.3653952 C4.46655611,10.2487562 4.40022112,6.89883914 4.40022112,6.89883914 C4.10171365,6.89883914 3.75898286,6.88778331 3.75898286,6.88778331 Z"></path><path d="M5.15201769,6.84355998 L5.6053068,14.2177999 C5.71586512,14.2951907 5.90381426,14.2620232 5.97014925,14.1956882 C5.94803759,13.0679934 5.94803759,6.75511332 5.94803759,6.75511332 L5.15201769,6.84355998 Z"></path> <path d="M7.00939746,6.54505252 L8.56826976,12.2056385 C8.68988391,12.238806 8.7893864,12.2056385 8.84466556,12.1393035 C8.72305141,11.5091211 7.7169707,6.35710337 7.7169707,6.35710337 C7.45163074,6.4344942 7.00939746,6.54505252 7.00939746,6.54505252 Z"></path><path d="M5.94803759,3.63736871 C6.02542841,4.2564953 6.09176341,5.16307352 5.94803759,5.50580431 C6.46766169,5.58319514 7.4405749,5.62741846 7.4405749,5.62741846 C7.54007739,5.40630182 7.52902156,4.82034273 7.51796573,4.51077944 C7.50690989,4.14593698 7.41846324,3.61525705 7.41846324,3.61525705 C6.96517413,3.71475954 6.42343836,3.74792703 5.94803759,3.63736871 Z"></path><path d="M7.70591487,5.50580431 C8.34715312,5.59425097 8.31398563,5.81536761 8.31398563,5.97014925 C8.31398563,6.16915423 8.2697623,6.29076838 7.86069652,6.4344942 C7.49585406,6.56716418 5.78220011,6.9541183 5.21835268,6.99834163 C4.65450525,7.04256495 3.4604754,7.00939746 2.32172471,6.84355998 C1.17191819,6.66666667 0.287451631,6.33499171 0.143725815,6.06965174 C1.58206781e-15,5.80431177 0.11055832,5.40630182 0.829187396,5.27363184 C1.53676064,5.14096186 3.32780542,5.11885019 4.22332781,5.17412935 C5.11885019,5.22940851 7.21945826,5.43946932 7.70591487,5.50580431 Z"></path> <path d="M4.04643449,0.210060807 C3.51575456,0.298507463 3.12880044,0.729684909 3.38308458,1.64731896 C3.62631288,2.56495301 4.73189608,3.7368712 6.44555003,3.81426202 C8.15920398,3.89165285 9.07683803,2.92979547 9.46379215,2.05638474 C9.85074627,1.18297402 9.90602543,0.243228303 9.14317302,0.165837479 C8.026534,0.0663349917 4.93090105,0.0663349917 4.04643449,0.210060807 Z"></path>                    </g>                </g>            </g>        </g>    </g></svg>');
		$('td.col-status span span').text('');

		
		if ($('.col-r_rent_net').length){
			$('.complex-list-wrapper-collapsible').append('<div class="complex-availability-legend"><div class="availability-legend__available"><span></span>Verfügbar</div><div class="availability-legend__reserved"><span></span>Reserviert</div><div class="availability-legend__sold"><span></span>Vermietet</div></div>');
		} else{
			$('.complex-list-wrapper-collapsible').append('<div class="complex-availability-legend"><div class="availability-legend__available"><span></span>Verfügbar</div><div class="availability-legend__reserved"><span></span>Reserviert</div><div class="availability-legend__sold"><span></span>Verkauft</div></div>');
		}



		$('.complex-unit-caret').html('<svg width="12px" height="5px" viewBox="0 0 12 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="Angebot" transform="translate(-1269.000000, -1771.000000)">            <g id="Group-3" transform="translate(1207.000000, 1449.000000)"></g>            <polyline id="Rectangle" stroke="#799E98" stroke-linecap="round" transform="translate(1275.000000, 1773.500000) scale(-1, 1) translate(-1275.000000, -1773.500000) " points="1280 1771 1275 1776 1270 1771"></polyline>        </g>    </g></svg>');
	
		var messagelabel = $('.complex-form-part-footer > div:first-child');
		if(!messagelabel.text().trim().endsWith("*")){
			$('.complex-form-part-footer > div:first-child').hide();
		}

		$("label[for^='complexFieldlegalName']").hide()
		$("input[id^='complexFieldlegalName']").hide()

		/* Complex Filter */

		if($('.complex-filter-wrapper')){
			$('.complex-filter-wrapper').prepend('<div class="filter-toggler"><svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Styleguide-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="Desktop-HD" transform="translate(-59.000000, -698.000000)">            <text id="Bei-grossen-Überbauu" font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" letter-spacing="0.228571429" fill="#727477">                <tspan x="59" y="578">Bei grossen Überbauungen möchten sie die Option haben Filter </tspan>                <tspan x="59" y="600">einzublenden. Bei kleineren Überbauungen soll das Icon nicht erscheinen. </tspan>                <tspan x="59" y="622">Die Filter sollen sich beim anklicken des Icons oben hineinschieben. </tspan>                <tspan x="59" y="644"></tspan>                <tspan x="59" y="666">Icon: </tspan>                <tspan x="59" y="688"></tspan>                <tspan x="59" y="710"></tspan>                <tspan x="59" y="732"></tspan>                <tspan x="59" y="754">Filter:</tspan>            </text>            <g id="Group-2" transform="translate(59.000000, 698.000000)">                <line x1="0.5" y1="1.5" x2="17.5" y2="1.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="4.5" cy="1.5" r="1.5"></circle>                <line x1="0.5" y1="6.5" x2="17.5" y2="6.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="14.5" cy="6.5" r="1.5"></circle>                <line x1="0.5" y1="11.5" x2="17.5" y2="11.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="8.5" cy="11.5" r="1.5"></circle>            </g>        </g>    </g></svg> Filter</div>');
		}

		$('.filter-toggler').on('click', function(){
			$(this).next().toggleClass('show-filters');

		});
		
		$('#livingspace_from').show();

		$(".complex-form-part .extradata select").after('<i class="fal fa-angle-down"></i>');

		$(".wpforms-field select").after('<svg width="12px" height="5px" viewBox="0 0 12 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="Angebot" transform="translate(-1269.000000, -1771.000000)">            <g id="Group-3" transform="translate(1207.000000, 1449.000000)"></g>            <polyline id="Rectangle" stroke="#799E98" stroke-linecap="round" transform="translate(1275.000000, 1773.500000) scale(-1, 1) translate(-1275.000000, -1773.500000) " points="1280 1771 1275 1776 1270 1771"></polyline>        </g>    </g></svg>');


	     var rangeFlaeche = document.getElementById('filteroption-flaeche');
	     var inputFlaecheFrom = document.getElementById('livingspace_from');
	     var inputFlaecheTo = document.getElementById('livingspace_to');

	     if (inputFlaecheFrom) {
	         if (inputFlaecheFrom.value !== '' && parseFloat(inputFlaecheFrom.value) !== Math.floor(parseFloat(inputFlaecheFrom.value))) {
	             inputFlaecheFrom.value = Math.floor(parseFloat(inputFlaecheFrom.value));
	         }
	     }
	     if (inputFlaecheTo) {
	         if (inputFlaecheTo.value !== '' && parseFloat(inputFlaecheTo.value) !== Math.ceil(parseFloat(inputFlaecheTo.value))) {
	             inputFlaecheTo.value = Math.ceil(parseFloat(inputFlaecheTo.value));
	         }
	     }
	     
	     if (rangeFlaeche) {
	         $('#livingspace_from').css('display', 'none');
	         $('#livingspace_to').css('display', 'none');
	         var sliderFlaecheMin = document.getElementById('filteroption-flaeche');
	         var MinValueFlaeche = sliderFlaecheMin.getAttribute('data-minlivingspace');
	         var MaxValueFlaeche = sliderFlaecheMin.getAttribute('data-maxlivingspace');
	         var MinValueFlaeche = Math.round(Number(MinValueFlaeche));
	         var MaxValueFlaeche = Math.round(Number(MaxValueFlaeche));

	         if (MinValueFlaeche  == MaxValueFlaeche){
	          MaxValueFlaeche = MinValueFlaeche + 1;
	         }

	         noUiSlider.create(rangeFlaeche, {
	             start: [ MinValueFlaeche, MaxValueFlaeche ],
	             step: 1, // Slider moves in increments of '10'
	             margin: 1, // Handles must be more than '20' apart
	             connect: true, // Display a colored bar between the handles
	             direction: 'ltr', // Put '0' at the bottom of the slider
	             orientation: 'horizontal', // Orient the slider vertically
	             behaviour: 'tap-drag', // Move handle on tap, bar is draggable
	             range: { // Slider can select '0' to '100'
	                 'min': MinValueFlaeche,
	                 'max': MaxValueFlaeche
	             },
	             format: {
	                 to: function ( value ) {
	                 return Math.round(value);
	                 },
	                 from: function ( value ) {
	                     return Math.round(value);
	                 }
	             }
	         });

	         var flaecheSliderValues = [
	             document.getElementById('flaeche-slider-lower-value'),
	             document.getElementById('flaeche-slider-upper-value')
	         ];

	         flaecheSliderValues[0].innerHTML = Math.round(MinValueFlaeche);
	         flaecheSliderValues[1].innerHTML = Math.round(MaxValueFlaeche);

	         rangeFlaeche.noUiSlider.on('update', function( values, handle ) {
	             flaecheSliderValues[handle].innerHTML = Math.round(values[handle]);
	         });

	         rangeFlaeche.noUiSlider.on('change', function( values, handle ) {
	             var value = values[handle];
	             
	             if ( handle ) {
	                 inputFlaecheTo.value = Math.round(value);
	             } else {
	                 inputFlaecheFrom.value = Math.round(value);
	             }
	             $('#complexFilterForm').change();
	         });

	         inputFlaecheFrom.addEventListener('change', function(){
	             rangeFlaeche.noUiSlider.set([Math.round(this.value), null]);
	         });

	         inputFlaecheTo.addEventListener('change', function(){
	             rangeFlaeche.noUiSlider.set([null, Math.round(this.value)]);
	         });
	     }


		/*var $grid = $('.grid').isotope({
	 	    itemSelector: '.grid-item'
	  	});


	  	$grid.imagesLoaded().progress( function() {
	  	  $grid.isotope('layout');
	  	});*/


		if ($('.content-wrapper__slider').length) {
			$('.content-wrapper__slider').each(function(index, slider){
				var flky = new Flickity( slider, {
					cellAlign: 'left',
					contain: true,
					imagesLoaded: true,
					prevNextButtons: true,
					pageDots: true,
					draggable: true,
					fade: true,
					wrapAround: true,
					bgLazyLoad: 2,
					arrowShape: { 
					  x0: 20,
					  x1: 65, y1: 50,
					  x2: 70, y2: 45,
					  x3: 30
					}
					//arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
				});
				window.addEventListener( 'load', function() {
				  flky.resize();
				});
				flky.on('dragStart', () => flky.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
				flky.on('dragEnd', () => flky.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );
			});
		}

		if ($('.content-wrapper__galery-slider').length) {
			$('.content-wrapper__galery-slider').each(function(index, slider){
				var flkygal = new Flickity( slider, {
					cellAlign: 'center',
					contain: true,
					imagesLoaded: true,
					prevNextButtons: true,
					pageDots: true,
					draggable: true,
					groupCells: true,
					bgLazyLoad: 2,
					initialIndex: 1,
					wrapAround: true,
					arrowShape: { 
					  x0: 20,
					  x1: 65, y1: 50,
					  x2: 70, y2: 45,
					  x3: 30
					}
				});
				window.addEventListener( 'load', function() {
				  flkygal.resize();
				});

				//dragging and lightgally fix
				flkygal.on('dragStart', () => flkygal.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
				flkygal.on('dragEnd', () => flkygal.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );
			});
		}


	  	if ($('.slider').length) {
			var slider = new Flickity('.slider', {
				cellAlign: 'left',
				fade: true,
				imagesLoaded: true,
				pageDots: false,
				prevNextButtons: false,
				draggable: false,
				autoPlay: 7000
			});
			window.addEventListener( 'load', function() {
			  slider.resize();
			});

			//dragging and lightgally fix
			slider.on('dragStart', () => slider.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
			slider.on('dragEnd', () => slider.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );
		}


	function htmlDecode(input) {
	  let doc = new DOMParser().parseFromString(input, "text/html");
	  return doc.documentElement.textContent;
	}

	if($('.cxm-spaces-inside').length){
		$('.complex-unit-header-row').each(function(index, headerRow) {
			var data = $(headerRow).data('json');
			var name = data['name'];

			var r_usable_space = data['r_usable_space'];
			var r_terrace_space = data['r_terrace_space'];
			var r_balcony_space = data['r_balcony_space'];
			var custom_1 = data['custom_1'];
			var custom_3 = data['custom_3'];

			if(custom_3.length){
				var custom_3_label = $(this).parents('tbody').prev('thead').find('.col-custom_3').text();
				if(custom_3_label.length){
					$('.col-custom_3').hide();
					$(headerRow).next('.complex-unit-detail-row').find('.detail-row-wrapper').prepend('<div class="cxm-detail-info"><b>' + htmlDecode(custom_3_label)  + ':</b>  ' + htmlDecode(custom_3) + '</div>');
				}
			}

			if(custom_1.length){
				var custom_1_label = $(this).parents('tbody').prev('thead').find('.col-custom_1').text();
				if(custom_1_label.length){
					$('.col-custom_1').hide();
					$(headerRow).next('.complex-unit-detail-row').find('.detail-row-wrapper').prepend('<div class="cxm-detail-info"><b>' + htmlDecode(custom_1_label)  + ':</b>  ' + htmlDecode(custom_1) + '</div>');
				}
			}

			if(r_balcony_space.length){
				var r_balcony_space_label = $(this).parents('tbody').prev('thead').find('.col-r_balcony_space').text();
				if(r_balcony_space_label.length){
					$('.col-r_balcony_space').hide();
					$(headerRow).next('.complex-unit-detail-row').find('.detail-row-wrapper').prepend('<div class="cxm-detail-info"><b>' + htmlDecode(r_balcony_space_label)  + ':</b>  ' + htmlDecode(r_balcony_space) + '</div>');
				}
				
			}

			if(r_terrace_space.length){
				var r_terrace_space_label = $(this).parents('tbody').prev('thead').find('.col-r_terrace_space').text();
				if(r_terrace_space_label.length){
					$('.col-r_terrace_space').hide();
					$(headerRow).next('.complex-unit-detail-row').find('.detail-row-wrapper').prepend('<div class="cxm-detail-info"><b>' + htmlDecode(r_terrace_space_label)  + ':</b>  ' + htmlDecode(r_terrace_space) + '</div>');
				}
			}


			if(r_usable_space.length){
				var r_usable_space_label = $(this).parents('tbody').prev('thead').find('.col-r_usable_space').text();
				if(r_usable_space_label.length){
					$('.col-r_usable_space').hide();
					$(headerRow).next('.complex-unit-detail-row').find('.detail-row-wrapper').prepend('<div class="cxm-detail-info"><b>' + htmlDecode(r_usable_space_label)  + ':</b>  ' + htmlDecode(r_usable_space) + '</div>');
				}
			}

			$(headerRow).next('.complex-unit-detail-row').find(".cxm-detail-info" ).wrapAll( "<div class='detail-info-wrapper' />");
		});
		
	}


	function endsWith(string, search){
		return string.substring( string.length - search.length, string.length ) === search;
	}

	$(".complex-unit-header-row").off('click');
	$('.complex-unit-header-row').off('click touchend');

	function highlightProjectUnit($headerRow, speed){
		speed = typeof speed !== 'undefined' ? speed : 0;
		var id = "#"+$headerRow.prop('id');
		$('.complex-project-graphic-interaction a').each(function(iindex, iel) {
			if (endsWith($(iel).attr("xlink:href"), id)) {
				//addClass
				$(iel).attr('class', function(index, classNames) {
					var re = /active/gi;
					classNames = classNames.replace(re, '');
					return classNames + ' active';
				});
			}
		});
		$('.complex-custom-overlays img').not('.active').fadeOut(speed);
		var $targetOverlay = $('.complex-custom-overlays img[data-show-on-active-unit="'+id+'"]');
		$targetOverlay.addClass('active').fadeIn(speed);

		//lazy load
		if ($targetOverlay.data('src')) {
			$targetOverlay.prop('src', $targetOverlay.data('src'));
			$targetOverlay.data('src', null);
		}

		$('.complex-tooltip-unit-item').hide();
		if ($('.complex-project-graphic:hover').length !== 0) {
			$('.complex-tooltip-unit-item[data-unit="'+id+'"]').closest('.complex-tooltip').show();
		}
		$('.complex-tooltip-unit-item[data-unit="'+id+'"]').show();
	}



	function activateProjectUnit($headerRow){
		$('.complex-tooltip').hide();
		$('.complex-project-graphic-interaction a').each(function(index, el) {
			// removeClass
			$(el).attr('class', function(index, classNames) {
				var re = /active/gi;
				classNames = classNames.replace(re, '');
				return classNames;
			});
		});



		if ($headerRow.hasClass('active')) {
			$headerRow.next().find('.detail-row-wrapper').slideUp('slow');
			$headerRow.removeClass('active');
			$headerRow.next().removeClass('active');
		} else {
	

			$headerRow.next().find('.detail-row-wrapper img').each(function(index, el) {
				if ($(el).data('src')) {
					$(el).prop('src',$(el).data('src'));
					$(el).prop('srcset',$(el).data('src'));
					$(el).data('src', null);
				}
			});

			//scrolltoheaderRow($headerRow, getCXMscrollOffset());

			$('.complex-unit-header-row.active').each(function(index, el) {

				$(el).next().find('.detail-row-wrapper').slideUp('slow');
				$(el).removeClass('active');
				$(el).next().removeClass('active');
			});


			$headerRow.next().find('.detail-row-wrapper').delay(300).slideDown('slow');
			$headerRow.addClass('active');
			$headerRow.next().addClass('active');

			/*$('html, body').animate({
				scrollTop: $headerRow.next().find('.detail-row-wrapper').offset().top - 100
			}, 500);*/

			highlightProjectUnit($headerRow);
		}
	}

	var dragging = false;
	$("body").on("touchmove", function(){
			dragging = true;
	});
	$("body").on("touchstart", function(){
		dragging = false;
	});

	$('.complex-unit-header-row').on('click touchend', function(event) {
		var row = this;
		var anchorclick = $(event.target).is('a');
		if (!anchorclick) {
			event.preventDefault();

			if (!dragging) {
				if ($('.complex-list-wrapper').hasClass('complex-list-wrapper-collapsible')) {
					$('.complex-custom-overlays img').removeClass('active').hide();
					activateProjectUnit($(this));
				} else {

					if ($('.complex-contact-form-wrapper').length) {
					$(".complex-contact-form-wrapper input:text, .complex-contact-form-wrapper textarea").first().focus();
						var unit_id = $(row).data('unit-id');
					$('.complex-contact-form-wrapper form [name="complex-unit-inquiry[unit_id]"]').val(unit_id);


					} else if($(row).find('.col-quick-download a').length){
						$(row).find('.col-quick-download a').first()[0].on('click', );
					} else if($(row).find('.col-quick-download').length){
						//silence
					} else {
						alert('form not found add it with [contactform-complex] or enable collapsible="1" property on [CXM-list] and make sure there is only one form available.');
					}
				}
			}
		}
	});

		
});



// WEBPACK FOOTER //
// ./src/js/main.js